module.exports = __webpack_public_path__ + "static/img/sc16.4c0938d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc16.png
// module id = wgma
// module chunks = 25